// extracted by mini-css-extract-plugin
export default {"containerHeaderForm":"HeaderForm_containerHeaderForm__94E9r","headerFormH1":"HeaderForm_headerFormH1__mU32r","x":"HeaderForm_x__t+i5+"};